import 'core-js/es6/map';
import 'core-js/es6/set';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

import App from './components/App';

require('core-js');
require('./lib/polyfill.js');
require('./lib/axiosConfig');

require('./infrastructure/actionTypes');
require('./infrastructure/DragTypes');
require('./infrastructure/interfaces');
require('./infrastructure/LoginStatus');
require('./infrastructure/PageType');
require('./infrastructure/placeholderTypes');
require('./infrastructure/ProductStatus');
require('./infrastructure/ProductType');
require('./infrastructure/Steps');
require('./infrastructure/TabTitles');
require('./infrastructure/tooltips');
require('./infrastructure/UsersRoles');

require('./services/UserService');
require('./services/SocketService');
require('./services/PageService');
require('./services/DocumentService');
require('./services/OrderService');

require('./reducers/adminOrdersList');
require('./reducers/agronomyReferenceSheetList');
require('./reducers/blankList');
require('./reducers/document');
require('./reducers/documentList');
require('./reducers/productList');
require('./reducers/seedList');
require('./reducers/editor');
require('./reducers/productLogosList');
require('./reducers/loading');
require('./reducers/options');
require('./reducers/orderCreated');
require('./reducers/orderList');
require('./reducers/seedCategoryList');
require('./reducers/seedIconList');
require('./reducers/statesList');
require('./reducers/techSheetList');
require('./reducers/user');
require('./reducers/userDownloadList');
require('./reducers/wizard');

require('./stores/store');

require('./actions/actions');
require('./actions/orderActions');


ReactDOM.render(
  <App />,
  document.getElementById('root') as HTMLElement
);



// WEBPACK FOOTER //
// ./src/index.tsx